import { render, staticRenderFns } from "./RegistroGrupos.vue?vue&type=template&id=5f3ee83a&"
import script from "./RegistroGrupos.vue?vue&type=script&lang=js&"
export * from "./RegistroGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports